import { render, staticRenderFns } from "./billing-upgrade-modal.vue?vue&type=template&id=08808d6a&scoped=true&"
import script from "./billing-upgrade-modal.vue?vue&type=script&lang=ts&"
export * from "./billing-upgrade-modal.vue?vue&type=script&lang=ts&"
import style0 from "./billing-upgrade-modal.vue?vue&type=style&index=0&id=08808d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08808d6a",
  null
  
)

export default component.exports